import { motion } from "framer-motion";
import { EASE } from "./motion-utils";

export const Fade = ({ d = 0, y = 26, className = "", children, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ delay: d, duration: 0.9, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Word-by-word mask reveal for headlines. Use "|" to force a line break.
export const WordReveal = ({ text, className = "", d = 0, stagger = 0.07, as = "h2" }) => {
  const Tag = motion[as] || motion.h2;
  const lines = text.split("|");
  let idx = 0;
  return (
    <Tag
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-70px" }}
      className={className}
      data-testid="word-reveal"
    >
      {lines.map((line, li) => (
        <span key={li} className="block">
          {line.trim().split(" ").map((w) => {
            const i = idx++;
            return (
              <span key={`${w}-${i}`} className="cg-word">
                <motion.span
                  className="cg-word-inner"
                  variants={{ hidden: { y: "110%", opacity: 0 }, show: { y: "0%", opacity: 1 } }}
                  transition={{ delay: d + i * stagger, duration: 0.85, ease: EASE }}
                >
                  {w}
                </motion.span>
              </span>
            );
          })}
        </span>
      ))}
    </Tag>
  );
};
